import React from 'react'
import { BREAKPOINT_SIZES } from '@consts/index'
import { useMediaQuery } from '@helpers/hooks'
import ProductCarousel from './ProductCarousel'
import { ProductGalleryImage } from './types'
import ProductGrid from './ProductGrid'

type ProductGalleryProps = {
  setIsImageGalleryOpen?: (isImageGalleryOpen: boolean) => void
  title: string
  images: ProductGalleryImage[]
}

function ProductGallery({
  title,
  images = [],
  setIsImageGalleryOpen = () => undefined
}: ProductGalleryProps) {
  const isDesktopUp = useMediaQuery({
    minWidth: BREAKPOINT_SIZES.DESKTOP,
    initialState: undefined
  })

  const [firstImage, secondImage, thirdImage, ...rest] = images

  const reorderdCarouselImagesList = [
    secondImage,
    firstImage,
    thirdImage,
    ...rest
  ].filter(image => image)

  if (isDesktopUp == null || isDesktopUp === true) {
    return (
      <ProductGrid
        images={reorderdCarouselImagesList}
        productName={title}
        setIsImageGalleryOpen={setIsImageGalleryOpen}
      />
    )
  }

  return (
    <ProductCarousel images={reorderdCarouselImagesList} productName={title} />
  )
}

const ProductGalleryMemoised = React.memo(ProductGallery)

export default ProductGalleryMemoised
